import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

// Hover + keyboard-focus tooltip for icon-only header controls. Opens below the bar so it never covers a neighbour.
export function HeaderTip({ label, enabled = true, children }) {
  if (!enabled) return children;
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent
        side="bottom"
        sideOffset={10}
        collisionPadding={12}
        data-testid={`header-tip-${slug(label)}`}
        className="rounded-lg px-3 py-1.5 text-xs font-semibold tracking-tight border-0 shadow-[0_10px_24px_rgba(26,39,68,0.22)]"
        style={{ background: "var(--bk-accent)", color: "#FFFFFF", fontFamily: "'Plus Jakarta Sans', sans-serif" }}
      >
        {label}
      </TooltipContent>
    </Tooltip>
  );
}
